import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatDrawer } from '@blocks-react/components/Drawer';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { MODAL_ACTIONS } from '../constants';
import { commonItemPropType } from '@app/components/pages/account/saved-list/declarations.propTypes';
import styles from './ShareListDrawer.module.scss';
import { BUTTON_VARIANTS } from '@app/constants/commonConstants';

const ShareListDrawer = ({
  children,
  isActive,
  closeShareListDrawer,
  shareListItem,
  isSelectedListEmpty,
  setConfirmationModalState,
  showError
}) => {
  const [t] = useTranslation();
  const { name } = shareListItem;
  const onCancelClick = () => {
    if (!isSelectedListEmpty) {
      setConfirmationModalState({
        isOpen: true,
        action: MODAL_ACTIONS.CANCEL_SHARE
      });
    } else {
      closeShareListDrawer();
    }
  };

  return (
    <CatDrawer
      isActive={isActive}
      poisition="right"
      disableBackdropClick
      onBlDrawerClose={onCancelClick}
      className={`${styles['share-list__drawer-container']}`}
    >
      <div slot="header">
        <CatHeading variant="title" level="h2">
          {t('REQUISITIONLIST_ACTION_SHARE_LIST')}
        </CatHeading>
        <CatHeading variant="body" level="h3">
          {name}
        </CatHeading>
      </div>
      {showError && (
        <div className="cat-u-margin-bottom-lg">
          <CatInlineNotification
            variant="error"
            heading={t('UNABLE_TO_SHARE_THE_SAVED_LIST')}
            dismissible
          >
            <CatIconWarningCircle slot="before" />
          </CatInlineNotification>
        </div>
      )}
      {children}
      <div slot="footer">
        <CatButton
          onClick={() => {
            setConfirmationModalState({
              isOpen: true,
              action: MODAL_ACTIONS.SHARE
            });
          }}
          disabled={isSelectedListEmpty}
        >
          {t('SHARE')}
        </CatButton>
        <CatButton onClick={onCancelClick} variant={BUTTON_VARIANTS.GHOST}>
          {t('CANCEL')}
        </CatButton>
      </div>
    </CatDrawer>
  );
};
ShareListDrawer.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  closeShareListDrawer: PropTypes.func,
  shareListItem: commonItemPropType,
  isSelectedListEmpty: PropTypes.bool,
  setConfirmationModalState: PropTypes.func,
  showError: PropTypes.bool
};
export default ShareListDrawer;
